export class Reward {
  rewardsEnabled: boolean;
  amountOff: number;
  afterVisits: number;
}
